<template>
  <div id="app">
    <main-header></main-header>
    <router-view/>
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainHeader from '@/components/partials/MainHeader'
import MainFooter from '@/components/partials/MainFooter'

export default {
  name: 'App',
  components: {
    MainHeader,
    MainFooter
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans:300,400,600,700');
  @import "../node_modules/bootstrap/scss/bootstrap.scss";
  @import "../src/assets/styles/bootstrap.scss";
  @import "../src/assets/styles/main.scss";

  body {
    margin: 0 !important;
  }
  .bm-burger-button{
    display: none;
  }
  @media screen and (max-width: $lg-breakpoint){
    .bm-burger-button {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue